import {BreakpointObserver} from "@angular/cdk/layout"
import {DestroyRef, inject, Injectable, signal} from "@angular/core"
import {takeUntilDestroyed} from "@angular/core/rxjs-interop"

@Injectable({
    providedIn: "root",
})
export class BreakpointsService {
    readonly breakpointObserver = inject(BreakpointObserver)
    readonly destroyRef = inject(DestroyRef)

    readonly $isMobileSmall = signal(false)
    readonly $isMobile = signal(false)
    readonly $isMobileLandscape = signal(false)
    readonly $isTablet = signal(false)
    readonly $isDesktop = signal(false)
    readonly $isDesktopLarge = signal(false)

    constructor() {
        this.breakpointObserver
            .observe(["(min-width: 320px)", "(min-width: 478px)", "(min-width: 767px)", "(min-width: 992px)", "(min-width: 1200px)"])
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((result) => {
                this.$isMobileSmall.set(result.breakpoints["(min-width: 320px)"])
                this.$isMobile.set(result.breakpoints["(min-width: 478px)"])
                this.$isMobileLandscape.set(result.breakpoints["(min-width: 767px)"])
                this.$isTablet.set(result.breakpoints["(min-width: 992px)"])
                this.$isDesktop.set(result.breakpoints["(min-width: 1200px)"])
                this.$isDesktopLarge.set(result.breakpoints["(min-width: 1992px)"])
            })
    }
}
